import { useEffect, useRef } from "react";
import { TAREFAS_AUTO_REFRESH_MS } from "@/config/constants";

type TarefasLoadFn = (opts?: { silent?: boolean }) => void | Promise<void>;

/**
 * Recarrega tarefas em segundo plano para refletir alterações feitas por outros usuários
 * (ex.: colaborador conclui tarefa compartilhada pelo chefe).
 */
export function useTarefasAutoRefresh(load: TarefasLoadFn): void {
  const loadRef = useRef(load);
  loadRef.current = load;

  useEffect(() => {
    const tick = () => {
      void loadRef.current({ silent: true });
    };

    const intervalId = window.setInterval(tick, TAREFAS_AUTO_REFRESH_MS);

    const onVisibility = () => {
      if (document.visibilityState === "visible") tick();
    };
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      window.clearInterval(intervalId);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);
}
